<template>
  <div :id="id">
    <span
      v-if="label"
      class="label"
    >{{ label }}<sup v-if="required">*</sup></span>
    <ul
      style="list-style: none;"
      :class="[
        'rs-radio-group',
        {
          'list-col-1': columns == 1,
          'list-col-2': columns == 2,
          'list-col-3': columns == 3,
          'list-col-4': columns == 4,
        },
      ]
      "
    >
      <li
        v-for="(option, i) in options"
        :key="i"
      >
        <RsFormRadio
          :id="`${(option.text || '').toLowerCase().replace(/ /g, '_')}-${i}-${id || ''}`"
          v-model="value"
          :name="`radio_group-${id}`"
          :value="option.value"
          :label="option.text"
          :disabled="disabled"
          normal-font
          @change="(value) => updateOption(value, i)"
        />
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'RsRadioGroup',

  props: {
    id: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    label: String,
    options: {
      type: Array as PropType<any[]>,
      default: () => [],
    },
    columns: Number,
    selected: {
      type: [String, Number, Boolean],
      default: '',
    },
  },

  emits: ['change', 'input'],
  data() {
    return {
      value: this.selected,
    };
  },
  watch: {
    selected() {
      this.value = this.selected;
    },
  },
  methods: {
    updateOption(value: any, index: number) {
      if (this.selected !== this.options[index].value) {
        this.value = this.options[index].value;
        this.$emit('change', this.options[index].value);
      }
    },
  },
});
</script>

<style lang="scss" scoped>
  @import '@/styles/_variables.scss';
  .rs-radio-group{
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    &.list-col-1{
      li{
        width: 100%;
      }
    }
    &.list-col-2{
      li{
        width: auto;
        margin-right: 1rem;
      }
    }
    &.list-col-3{
      li{
        width: auto;
        margin-right: 1rem;
      }
    }
    &.list-col-4{
      li{
        width: auto;
        margin-right: 1rem;
      }
    }
    &.stacked{
      li{
        width: 100%;
        display: flex;
      }
    }
  }
</style>
